import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { timer } from 'rxjs';
import { passwordsCheck, resetPassword } from '../entidades/entidades.component';
import { ChangePasswordService } from '../servicios/change-password.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-password-card',
  templateUrl: './change-password-card.component.html',
  styleUrls: ['./change-password-card.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ChangePasswordCardComponent implements OnInit {

  // regExPassword: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,15}[^'\s]/;
  regExPassword: RegExp = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,15}$/;
  regExPasswordSCP: RegExp = /^(?=(?:.*\d){1})(?=(?:.*[A-Z]){1})(?=(?:.*[a-z]){1})(?=(?:.*[@$?+*¡\-_]){1})\S{8,15}$/;
  hasCapitalCase: RegExp = /[A-Z]/;
  hasLowerCase: RegExp = /[a-z]/;
  hasNumber: RegExp = /\d/;
  // passLength: RegExp = /^\w{8,15}$/;
  errorCapitalCase: boolean = true;
  errorLowerCase: boolean = true;
  errorHasNumber: boolean = true;
  errorPassLength: boolean = true;
  errorPassNotMatch: boolean = true;
  errorPassSC: boolean = true;
  checkPasswordReGex: boolean = false;
  errorRegEx: string = '';
  errors: boolean = true;

  timer: any;
  subscription: any;

  hide: boolean = true;
  passwordsOK: boolean = true;

  errorsMsgFromBack: string = ''
  user: string = '';
  ID: string = '';
  loading: boolean = false;

  vcaURL: string = '';

  model = {
    password: '',
    password2: ''
  }

  constructor(private passSvc: ChangePasswordService, private _snackBar: MatSnackBar) {
    this.validateID()
    this.checkEnviroment()
  }

  ngOnInit(): void { }

  // observa los cambios que se hagan en el formulario, es como un OnChange

  @ViewChild('changePasswordForm') form: any

  ngAfterViewInit() {
    this.form.control.valueChanges
      .subscribe((passwords: passwordsCheck) => this.checkPassRequirements(passwords));
  }

  checkPassRequirements(passwords: passwordsCheck) {
    if (this.hasCapitalCase.test(passwords.password)) this.errorCapitalCase = false
    else this.errorCapitalCase = true
    if (this.hasLowerCase.test(passwords.password)) this.errorLowerCase = false
    else this.errorLowerCase = true
    if (this.hasNumber.test(passwords.password)) this.errorHasNumber = false
    else this.errorHasNumber = true
    // if (this.passLength.test(passwords.password)) this.errorPassLength = false
    // else this.errorPassLength = true
    if (passwords.password.length > 8 || passwords.password.length < 15) this.errorPassLength = false
    else this.errorPassLength = true
    if (passwords.password === passwords.password2) this.errorPassNotMatch = false
    else this.errorPassNotMatch = true


    if (!this.errorCapitalCase && !this.errorLowerCase && !this.errorHasNumber
      && !this.errorPassLength && passwords.password === passwords.password2) {
      this.errors = false
    } else {
      this.errors = true
    }
  }


  // verifica en que ambiente estamos y reedireciona corectamente

  checkEnviroment() {
    this.vcaURL = environment.URL_Web
    console.log('this.vcaURL : ', this.vcaURL)
  }

  // valida el id que viene por URL

  validateID() {
    this.takeID()
    this.passSvc.validateUniqueID(this.ID).subscribe({
      error: (e) => {
        if (e.status === 200) {
          this.user = e.error.text
          console.log('Usuario válido:', this.user)
        }
        else if (!this.ID) {
          window.location.href = (this.vcaURL) 
        }
        else {
          this.errorsMsgFromBack = e.error.errors[0].message
          console.log('Error con timer - Mensaje:', this.errorsMsgFromBack)
          console.log('Redirigiendo en 2 segundos a:', this.vcaURL)
          this.timer = timer(2000)
          this.subscription = this.timer.subscribe(() => {
            window.location.href = (this.vcaURL)
          });
        }
      },
      complete: () => console.info('complete')
    })
  }

  takeID() {
    let idIndex = window.location.href.lastIndexOf('/')
    this.ID = window.location.href.slice(idIndex + 1)
  }

  // notificaciones

  openSnackBar(message: string) {
    this.loading = false
    console.log('Redirigiendo después del snackBar a:', this.vcaURL)
    let snackBarRef = this._snackBar.open(message, '', {
      duration: 2000
    });
    snackBarRef.afterDismissed().subscribe(() => {
      window.location.href = (this.vcaURL)
    });
  }

  // verifica si la contraseña es valida (reevisar si es necesario que siga estando)

  checkPassword() {
    this.checkPasswordReGex = this.regExPassword.test(this.model.password)
    let passSC = this.regExPasswordSCP.test(this.model.password)
    if (!this.checkPasswordReGex && !passSC) {
      this.errorRegEx = 'La contraseña no cumple con los requisitos de seguridad'
    } else {
      this.errorRegEx = ''
    }
  }

  // se envian las contraseñas al back

  submit() {
    this.checkPassword()
    if (this.model.password === this.model.password2 && this.checkPasswordReGex) {
      this.passwordsOK = true
      let userData: resetPassword = {
        username: this.user,
        password: this.model.password,
        uniqueId: this.ID
      }
      this.loading = true
      this.passSvc.postNewPassword(userData).subscribe(() => {
        this.openSnackBar('Contraseña cambiada con éxito')
      }, e => {
        this.openSnackBar(e.error.errors[0].message)
      })
    } else {
      this.passwordsOK = false
    }
  }
}
